import { render, staticRenderFns } from "./select.vue?vue&type=template&id=650ae362&scoped=true&lang=pug"
import script from "./select.vue?vue&type=script&lang=coffee"
export * from "./select.vue?vue&type=script&lang=coffee"
import style0 from "./select.vue?vue&type=style&index=0&id=650ae362&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ae362",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Chevron: require('/opt/build/repo/site/components/globals/chevron.vue').default})
